<template>
	<div class="flex-column">
		<div class="full-height overflow-y-auto pb-50 mb-10">
			<div>

				<div class="justify-space-between gap-10 items-center">
					<h6 class="h6">
						{{ item.rDate }}
					</h6>
					<div><span v-if="false" class="label" :class="'label-' + item.status_color">{{ item.status_name }}</span></div>
				</div>

				<div
					class="mt-10 box pa-10 radius-10"
					:inner-html.prop="item.report_content | nl2br"
				></div>

				<div class="mt-10 text-right">등록 일시: {{ item.wDate }}</div>

				<template
					v-if="item.report_message"
				>
				<h6 class="h6 mt-10">반려 사유</h6>
				<div
					class="mt-10 box pa-10 radius-10"
					:inner-html.prop="item.report_message | nl2br"
				></div>

					<div class="mt-10 text-right">반려 일시: {{ item.wDate }}</div>
				</template>

				<h6 class="h6 mt-10">첨부파일</h6>

				<div class="mt-10">
					<ul
						v-if="items_file.length > 0"
					>
						<template
							v-for="file in items_file"
						>
							<li
								:key="'file_' + file.uid"
								class="mb-10 box radius-10 pa-10"
							>
								<img :src="file.file_path" class="object-cover radius-10" width="100" height="400" loading="lazy" />

								<div
									v-if="file.file_date"
									class="mt-10"
								>등록 일시: {{ file.wDate }}</div>
								<div
									v-if="file.file_date"
									class="mt-10"
								>촬영 일시: {{ file.file_date }}</div>
								<div
									v-else
									class="mt-10"
								>촬영일 정보 없음</div>

								<div
									v-if="file.file_gps"
									class="mt-10"
								>
									<a :href="'https://www.google.com/maps?q=' + file.file_gps " target='_blank'>구글 지도에서 보기</a>
								</div>
								<div
									class="mt-10"
									v-else
								>위치 정보 없음</div>
							</li>
						</template>
					</ul>
					<Empty
						v-else
					>첨부파일 없습니다</Empty>
				</div>
			</div>
		</div>

		<div
			v-if="user.member_level == '1'"
			class="mt-auto"
		>
			<button
				class="btn-full btn-primary"
				@click="toDetail"
			>정보수정</button>
		</div>

		<div
			v-else-if="Number(user.member_level) == 2"
			class="mt-auto justify-space-between gap-10"
		>
			<button
				v-if="item.report_status == '1' || item.report_status == '4'"
				class="btn-full btn-primary"
				@click="postReportStatus('confirm')"
			>1차 승인</button>
			<button
				v-if="item.report_status == '1' || item.report_status == '4'"
				class="btn-full btn-danger"
				@click="onReturn"
			>1차 승인 반려</button>
		</div>

		<div
			v-else-if="Number(user.member_level) == 3"
			class="mt-auto justify-space-between gap-10"
		>
			<button
				v-if="item.report_status == '2' || item.report_status == '7'"
				class="btn-full btn-primary"
				@click="postReportStatus('confirm')"
			>최종 승인</button>
			<button
				v-if="item.report_status == '2' || item.report_status == '7'"
				class="btn-full btn-danger"
				@click="onReturn"
			>최종 승인 반려</button>
		</div>

		<PopupConfirm
			v-if="is_on_return"

			@cancel="offReturn"
			@click="postReturn"
		>
			<template
				slot="title"
			>작업일지 반려</template>
			<template
				slot="content"
			>
				<textarea v-model="return_message" class="input-box" placeholder="사유를 입력하세요">
				</textarea>
			</template>
		</PopupConfirm>
	</div>
</template>
<script>

import Empty from "../Layout/Empty";
import PopupConfirm from "../Layout/PopupConfirm";
export default {
	name: 'ProjectReportView'
	,
	components: {PopupConfirm,  Empty},
	props: ['user']
	, data: function(){
		return {
			program: {
				name: '작업일지 상세 정보'
				, not_top: true
				, title: true
				, bottom: false
				, is_container: true
				, from: 'ProjectTaskView'
				, params: {
					idx: this.$route.params.idx
				}
			}
			, item: {
				work_content: ''
			}
			, report_idx: this.$route.params.idx
			, items_file: []
			, is_on_return: false
			, item_return_message: ''
			, return_message: ''
		}
	}
	, methods: {
		getData: async function(){
			this.$bus.$emit('on', true)
			try {
				const result = await this.$request.init({
					method: 'get'
					, url: 'project/getProjectReport'
					, data: {
						idx: this.report_idx
					}
				})

				if(result.success){
					this.item = result.data.report_info
					this.items_file = result.data.file_list

					this.program.params.idx = this.item.task_uid
				}else{
					throw result.message
				}
			}catch (e){
				this.$bus.$emit('notify', { type: 'error', message: e})
			}finally {
				this.$bus.$emit('on', false)
			}
		}
		, toDetail: function (){
			this.$bus.$emit('to', {name: 'ProjectReportDetail', params: { idx: this.report_idx}})
		}
		, postReportStatus: async function(type){

			let t = '처리 하시겠습니까?'

			switch (type){
				case 'confirm':
					t = '승인' + t
				break;
				case 'return':
					t = '반려' + t
				break;
			}

			if(!confirm(t)){
				return false
			}
			this.$bus.$emit('on', true)
			try {
				const result = await this.$request.init({
					method: 'post'
					, url: 'project/postReportStatus'
					, data: {
						idx: this.report_idx
						, report_status_type: type
						, return_message: this.return_message
					}
				})

				if(result.success){
					this.$bus.$emit('notify', { type: 'success', message: result.message})
					await this.getData()
				}else{
					throw result.message
				}

			}catch (e){
				this.$bus.$emit('notify', { type: 'error', message: e})
			}finally {
				this.$bus.$emit('on', false)
				this.is_on_return = false
			}
		}
		, onReturn: function(){
			this.is_on_return = true
			this.return_message = ''
		}
		, offReturn: function(){
			this.is_on_return = false
			this.return_message = ''
		}
		, postReturn: function(){
			this.postReportStatus('return')
		}
	}
	, created() {
		this.$bus.$emit('onLoad', this.program)
		this.getData()
	}
}
</script>